const jsonFromDocument = (elementId: string, defaultJson = "{}") =>
  JSON.parse(document.getElementById(elementId)?.textContent || defaultJson);

export default jsonFromDocument;
